module.exports = __webpack_public_path__ + "static/clients_image-b895b37666cf1cb2bbf09d949af83c7e.jpg";